export const MEDIA_UPLOAD_LIMITS = {
  MAX_FILE_SIZE_BYTES: 1 * 1024 ** 3, // max individual file size (1GB)
  MAX_BATCH_SIZE_BYTES: 10 * 1024 ** 3, // max batch size (10GB)
  MAX_FILE_NAME_LENGTH: 200, // max filename length
  MAX_FILES_PER_BATCH: 1000 // max files per batch
}
